import ActivationRange from './ActivationRange.view';

export default ActivationRange;